import {dark, light} from './themes';

export const themeData = {
    defaultTheme: light,
    secondaryTheme: dark
};